import React from "react";
import VersionedLegalDocument from "./VersionedLegalDocument";

export default function UserAgreement() {
  return <VersionedLegalDocument documentType={["ru_public_offer", "terms"]} />;
}
